import { render, staticRenderFns } from "./RefLinks.vue?vue&type=template&id=5bbdfffc&scoped=true"
import script from "./RefLinks.vue?vue&type=script&lang=js"
export * from "./RefLinks.vue?vue&type=script&lang=js"
import style0 from "./RefLinks.vue?vue&type=style&index=0&id=5bbdfffc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbdfffc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VDataTable,VIcon,VProgressCircular})
